import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { CheckIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { useIsMobile } from '../../hooks/useIsMobile';

interface TextWithCheckProps {
    text: string;
}

const TextWithCheck: React.FC<TextWithCheckProps> = ({ text }) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <Stack direction={'row'} alignItems={'center'} flexShrink={0}>
                <Container width="16px">
                    <CheckIcon size={'sm'} color={'grey_1200'} />
                </Container>
                <Text size={'b_sm'}>{text}</Text>
            </Stack>
        );
    }

    return (
        <Stack direction={'row'}>
            <CheckIcon size={'md'} color={'grey_1200'} />
            <Text>{text}</Text>
        </Stack>
    );
};

export default TextWithCheck;
